import React from "react";

// Official WhatsApp glyph as inline SVG so it scales & inherits color when needed.
export default function WhatsAppIcon({ size = 20, className = "", color = "currentColor" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill={color}
        d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.15-.53 2.478-1.318.13-.302.13-.63.187-.945-.13-.216-1.276-.716-1.65-.888m-2.607 5.257c-1.647 0-3.265-.415-4.68-1.263L7.83 22.207l1.05-3.9c-.9-1.512-1.4-3.267-1.4-5.05 0-5.507 4.542-9.98 10.023-9.98a9.98 9.98 0 0 1 9.98 9.98c0 5.478-4.5 10.02-9.98 10.02m0-21.457c-6.323 0-11.475 5.152-11.475 11.475 0 1.955.502 3.88 1.457 5.564L4 27.535l6.578-1.727a11.53 11.53 0 0 0 5.554 1.417c6.325 0 11.475-5.152 11.475-11.475 0-3.063-1.19-5.94-3.358-8.11a11.4 11.4 0 0 0-8.117-3.35"
      />
    </svg>
  );
}
